import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { InstrumentDetailsService } from '@zero/instrument-details/domain';
import { IsKnockedOutPipe } from '@zero/shared/ui-pipes';

@Component({
  selector: 'instrument-details-knocked-out-hint',
  imports: [TranslocoPipe, IsKnockedOutPipe, AsyncPipe],
  templateUrl: './knocked-out-hint.component.html',
})
export class KnockedOutHintComponent {
  public readonly service = inject(InstrumentDetailsService);
}
